
import { Component, Prop, Mixins } from 'vue-property-decorator';
import HasInteracted from '~/mixins/HasInteracted';
import LoginBase from '~/mixins/LoginBase';

@Component({
	name: 'BusinessHeaderSection',
	components: {
		ErrorBox: () => import('@hokify/shared-components/lib/components/ErrorBox.vue')
	}
})
export default class BusinessHeaderSection extends Mixins(HasInteracted, LoginBase()) {
	@Prop({
		type: Object,
		required: true
	})
	// when using imageHeight+imageWidth use exact size (or within aspect ratio) to ensure sharp images
	readonly headerItems!: {
		wordMark?: string;
		image: string;
		imageHeight?: number;
		imageWidth?: number;
		/* Use the below props to set height and width attributes for a fullsize header image */
		fullSizeImageHeight?: number;
		fullSizeImageWidth?: number;
		headlineOne: string;
		headlineTwo?: string;
		headlineThree?: string;
		subHeadline: string;
		buttonText?: string;
		poster?: boolean;
	};

	@Prop({
		type: Boolean,
		default: false
	})
	readonly hideForm!: boolean;

	get imageClasses(): string {
		let imageClasses;

		if (this.headerItems?.imageHeight && !this.headerItems.poster) {
			imageClasses = 'bottom-2 xl:bottom-8';
		} else if (this.headerItems.poster) {
			imageClasses = ' top-40 poster';
		} else {
			imageClasses = 'bottom-0 w-auto h-full';
		}
		return imageClasses;
	}
}
